import { ComponentProps, StrapiComponent } from '@/services/models';
import { componentMap } from '@/lib/component-map';

interface ComponentFactoryProps {
  section: StrapiComponent & ComponentProps;
  index: number;
  locale: string;
  /**
   * Set only for the page's first (above-the-fold) section so its image is
   * preloaded as the LCP candidate. Never set it for below-the-fold sections:
   * extra preloads compete with the real LCP resource.
   */
  prerender?: boolean;
}

const componentFactory = ({
  section,
  index,
  locale,
  prerender,
}: ComponentFactoryProps) => {
  const Component = componentMap[section.__component];

  if (!Component) {
    return null;
  }

  return (
    <Component key={index} {...section} locale={locale} prerender={prerender} />
  );
};

export default componentFactory;
